const offerSnapshot = JSON.parse(document.querySelector("#offer-snapshot")?.textContent || "null") || JSON.parse(document.querySelector("#commerce-data")?.textContent || "{}").offerSnapshot;
/* Approved storefront prices in integer grosze. Shopify owns actual cart/checkout
   prices. These display totals do not create or apply a Shopify discount. */
window.VALENI_CATALOG = {
projector: {
 name: window.valeniT('js_projector_name'), hasSizes:false,
 unitPrice:0, referencePrice:0,
 sizes:[{key:'christmas',label:window.valeniT('js_christmas_version')}], variantIds:{christmas:null},
 bundles:[
 {id:'single',label:window.valeniT('js_single'),quantity:1,totalPrice:null,expectedTotal:null,historicalLow:null,discountLabel:"30% TANIEJ!",automaticDiscount:0,copy:'',badge:''},
 {id:'double',label:window.valeniT('js_double'),quantity:2,totalPrice:null,expectedTotal:null,historicalLow:null,discountLabel:"40% TANIEJ!",automaticDiscount:0,copy:window.valeniT('js_second_projector'),badge:window.valeniT('js_popular')},
 {id:'family',label:window.valeniT('js_family'),quantity:4,totalPrice:null,expectedTotal:null,historicalLow:null,discountLabel:"3+1 GRATIS!",automaticDiscount:0,copy:window.valeniT('js_fourth_free'),badge:window.valeniT('js_best_offer')}
 ]
}
};
const valeniPage = JSON.parse(document.querySelector('#commerce-data')?.textContent || '{}');
window.VALENI_OFFER = window.VALENI_CATALOG[valeniPage.productKey] || window.VALENI_CATALOG.projector;
window.valeniBundleQuote = bundle => ({quantity:bundle.quantity, total:bundle.totalPrice});
window.VALENI_VARIANTS = {
  find(variants, size) {
    const configured = window.VALENI_OFFER.variantIds[size];
    if (!window.VALENI_OFFER.hasSizes && configured == null) return variants.length === 1 ? variants[0] : undefined;
    if (configured != null) { const match = variants.find(v => String(v.id) === String(configured)); if (match) return match; }
    const normalize = value => String(value).replace(/\s/g, '').replace(',', '.').replace(/m$/i, '');
    return variants.find(v => (v.options || [v.title]).some(option => normalize(option) === size));
  },
  // Aggregate identical real variants, without mutating the individual selections.
  lineItems(variants, sizes, bundle) {
    if (sizes.length !== bundle.quantity) throw new Error(window.valeniT('js_choose_sizes'));
    const lines = new Map();
    sizes.forEach(size => {
      const variant = this.find(variants, size);
      if (!variant?.available) throw new Error(window.valeniT('js_size_unavailable'));
      const key = String(variant.id);
      if (lines.has(key)) lines.get(key).quantity += 1;
      else lines.set(key, {id:variant.id, quantity:1, properties:{_valeni_product:valeniPage.productKey}});
    });
    return [...lines.values()];
  }
};

window.VALENI_PRICING = {configured:false, error:'', expectedBase:offerSnapshot.base};
const valeniVariant = valeniPage.variants?.find(v => v.available) || valeniPage.variants?.[0];
window.VALENI_OFFER.unitPrice = valeniPage.preview ? offerSnapshot.base : Number(valeniVariant?.price || 0);
window.VALENI_OFFER.referencePrice = window.VALENI_OFFER.unitPrice;
const snapshotValid = valeniPage.preview || (valeniPage.currency === offerSnapshot.currency && Number(valeniVariant?.id) === offerSnapshot.variantId && window.VALENI_OFFER.unitPrice === offerSnapshot.base);
window.VALENI_OFFER.bundles.forEach(bundle => {
  const approved = offerSnapshot.bundles.find(b => b.quantity === bundle.quantity);
  bundle.expectedTotal = approved.total; bundle.historicalLow = approved.historicalLow;
  bundle.totalPrice = snapshotValid ? approved.total : null;
  bundle.displayable = snapshotValid; bundle.verified = false;
});
window.VALENI_QUOTE_QUERY = `mutation OfferQuote($input: CartInput!) {
  cartCreate(input: $input) {
    cart { totalQuantity cost { subtotalAmount { amount currencyCode } }
      discountAllocations { discountedAmount { amount currencyCode } }
      lines(first: 10) { nodes { quantity merchandise { ... on ProductVariant { id price { amount currencyCode } } } } }
    }
    userErrors { message }
  }
}`;
window.valeniAcceptQuote = (quantity, total, base, currency) => {
  const bundle = window.VALENI_OFFER.bundles.find(b => b.quantity === quantity);
  if (!bundle) return false;
  const valid = currency === 'PLN' && base === window.VALENI_OFFER.unitPrice && base === window.VALENI_PRICING.expectedBase && total === bundle.expectedTotal;
  bundle.totalPrice = valid ? total : null;
  bundle.verified = valid; bundle.displayable = valid;
  if (!valid) window.VALENI_PRICING.error = window.valeniT('js_quote_mismatch');
  window.VALENI_PRICING.configured = window.VALENI_OFFER.bundles.every(b => b.verified);
  return valid;
};
window.valeniLoadQuotes = async () => {
  const offer = window.VALENI_OFFER;
  if (valeniPage.preview) {
    offer.bundles.forEach(b => window.valeniAcceptQuote(b.quantity, b.expectedTotal, offerSnapshot.base, 'PLN'));
    return;
  }
  if (!valeniVariant || valeniPage.currency !== 'PLN' || offer.unitPrice !== offerSnapshot.base) {
    window.VALENI_PRICING.error = window.valeniT('js_quote_mismatch');
    return;
  }
  const cacheKey = 'valeni-quotes:' + offerSnapshot.revision + ':' + valeniPage.country + ':' + valeniPage.currency;
  try { const cached = JSON.parse(sessionStorage.getItem(cacheKey)); if (cached && Date.now()-cached.at < 300000 && cached.base === offer.unitPrice && cached.totals.every((total,i) => total === offer.bundles[i].expectedTotal)) { offer.bundles.forEach((b,i) => window.valeniAcceptQuote(b.quantity,cached.totals[i],cached.base,valeniPage.currency)); return; } } catch {}
  await Promise.all(offer.bundles.map(async bundle => {
    try {
      const response = await fetch('/api/2026-10/graphql.json', {
        method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json'},
        body:JSON.stringify({query:window.VALENI_QUOTE_QUERY,variables:{input:{
          buyerIdentity:{countryCode:valeniPage.country || 'PL'},
          attributes:[{key:'_valeni_purpose',value:'offer_verification'}],
          lines:[{merchandiseId:`gid://shopify/ProductVariant/${valeniVariant.id}`,quantity:bundle.quantity}]
        }}}), signal:AbortSignal.timeout(15000)
      });
      const result = await response.json(), payload = result.data?.cartCreate, cart = payload?.cart;
      if (!response.ok || result.errors?.length || payload?.userErrors?.length || !cart || cart.totalQuantity !== bundle.quantity) throw Error('quote');
      const cents = value => Math.round(Number(value) * 100);
      const total = cents(cart.cost.subtotalAmount.amount) - cart.discountAllocations.reduce((sum,d) => sum + cents(d.discountedAmount.amount), 0);
      const baseMatches = cart.lines.nodes.every(line => line.merchandise.id === `gid://shopify/ProductVariant/${valeniVariant.id}` && cents(line.merchandise.price.amount) === offer.unitPrice);
      window.valeniAcceptQuote(bundle.quantity, total, baseMatches ? offer.unitPrice : 0, cart.cost.subtotalAmount.currencyCode);
    } catch {
      window.VALENI_PRICING.error = window.valeniT('js_quote_unavailable');
    }
  }));
  if (window.VALENI_PRICING.configured) { try { sessionStorage.setItem(cacheKey,JSON.stringify({at:Date.now(),base:offer.unitPrice,totals:offer.bundles.map(b=>b.totalPrice)})); } catch {} }
};

window.valeniDeliveryEstimate = (now = new Date()) => {
  const parts = Object.fromEntries(new Intl.DateTimeFormat('en-CA',{timeZone:'Europe/Warsaw',year:'numeric',month:'numeric',day:'numeric'}).formatToParts(now).map(p=>[p.type,p.value]));
  const date = new Date(Date.UTC(Number(parts.year),Number(parts.month)-1,Number(parts.day)));
  const easter = year => {
    const a=year%19,b=Math.floor(year/100),c=year%100,d=Math.floor(b/4),e=b%4,f=Math.floor((b+8)/25),g=Math.floor((b-f+1)/3),h=(19*a+b-d-g+15)%30,i=Math.floor(c/4),k=c%4,l=(32+2*e+2*i-h-k)%7,m=Math.floor((a+11*h+22*l)/451),n=h+l-7*m+114;
    return new Date(Date.UTC(year,Math.floor(n/31)-1,n%31+1));
  };
  const holiday = d => {
    const key=`${d.getUTCMonth()+1}-${d.getUTCDate()}`;
    if (['1-1','1-6','5-1','5-3','8-15','11-1','11-11','12-24','12-25','12-26'].includes(key)) return true;
    const offset=Math.round((d-easter(d.getUTCFullYear()))/86400000);
    return [0,1,49,60].includes(offset);
  };
  const weekdays=document.documentElement.lang==='de'?['So','Mo','Di','Mi','Do','Fr','Sa']:['Nd','Pn','Wt','Śr','Cz','Pt','So'];
  let first,last,count=0;
  while(count<5){date.setUTCDate(date.getUTCDate()+1);if([0,6].includes(date.getUTCDay())||holiday(date))continue;count++;const label=`${weekdays[date.getUTCDay()]} ${date.getUTCDate()}`;if(count===3)first=label;if(count===5)last=label;}
  return window.valeniT('js_delivery_estimate',{range:`${first} – ${last}`});
};
